/**
 * Constantes comunes a las vistas de Cuotas (ActualizarValores y
 * AjustarDesactualizadas) y a sus modales de confirmacion.
 *
 * (Nota) Los valores de ACTUALIZACION_* tienen que coincidir con los del
 * backend (Cuotas/serializers.py), se mandan tal cual en el request.
 */
export const CATEGORIA_VENTA = 'Venta'
export const CATEGORIA_SERVICIO = 'Servicio'
export const CATEGORIA_ESCRITURA =  'Escritura'

export const ACTUALIZACION_FIJO = 'Fijo';
export const ACTUALIZACION_PORCENTUAL = 'Porcentual';



// WEBPACK FOOTER //
// ./src/views/Cuotas/constants.js